export default __webpack_public_path__ + "media/images/proof_providers/keybase-ef32a0725245c533c005c1548908bc1b.png";